const state = {
    emailForwards: []
};

const getters = {
    getEmailForwards: state => state.emailForwards
};

const mutations = {
    setEmailForwards(state, emailForwards = []) {
        state.emailForwards = emailForwards;
    }
};

const actions = {
    getEmailAlias({commit}, applicantId){
        return state.emailForwards.find(email => {
            return email.applicant_id == applicantId
        })
    },
    /**
     *
     * @param {Object} commit
     * @param {Object} payload
     */
    retrieveEmailForwards({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios
                .get(
                    `/api/v2/applications/${payload.application_id}/_modules/email_forwards`,
                    {
                        headers: { Authorization: "Bearer " + payload.token }
                    }
                )
                .then(res => {
                    commit("setEmailForwards", res.data);
                    resolve(res);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
